module.exports = __webpack_public_path__ + "img/ltkfitness-2x.29ed40d.jpg";